import { z } from 'zod';
/** The smaller quantity a ticket is re-planned to, whether or not the difference is split off. */
export const workOrderTargetInputSchema = z.object({
    qtyTarget: z
        .number()
        .positive('Quantity target must be greater than zero.')
        .max(1_000_000_000, 'Quantity target must be 1,000,000,000 or less.'),
});
//# sourceMappingURL=work-order-target-input.js.map